// extracted by mini-css-extract-plugin
module.exports = {"iso__breadCrumb":"BreadCrumb_iso__breadCrumb__Akba4","prevent_click":"BreadCrumb_prevent_click__EuzRq"};